import { AppState, Auth0Provider } from "@auth0/auth0-react";
import React, { PropsWithChildren } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate = ({ children }: PropsWithChildren<Auth0ProviderWithNavigateProps>): React.JSX.Element | null => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_AUTH0_CALLBACK_URL;
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

  const authorizationParams: Record<string, any> = {
    audience: audience,
    redirect_uri: redirectUri
  };

  if (location.pathname === "/join") {
    const ref = searchParams.get("ref");
    if (ref) {
      authorizationParams.ref = ref;
    }
  }

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider domain={domain} clientId={clientId} authorizationParams={authorizationParams} onRedirectCallback={onRedirectCallback}>
      {children}
    </Auth0Provider>
  );
};
